import i18n, { InitOptions } from 'i18next';
import { getCookie } from '../utils/cookies';
import { commonAR, commonDE, commonEN, exceptionsEN, validationEN } from './locales';

/* types */
export type localesType = 'en' | 'de' | 'ar';
export type moduleNamespacesType =
  | 'innovation'
  | 'school'
  | 'nomad'
  | 'smartZone'
  | 'satV1Zone'
  | 'satV3Zone'
  | 'satV4Zone'
  | 'satV5Zone'
  | 'challengeZone'
  | 'workflowZone'
  | 'contentZone'
  | 'defaultSchoolZone'
  | 'timeTableZone';
export type namespacesType = 'common' | 'validation' | 'exceptions' | moduleNamespacesType;
export interface languageType {
  code: string;
  title: string;
}

/* constants */
export const locales: localesType[] = ['en', 'de', 'ar'];
export const namespaces: namespacesType[] = [
  'common',
  'validation',
  'exceptions',
  'innovation',
  'school',
  'nomad',
  'smartZone',
  'satV1Zone',
  'satV4Zone',
  'satV5Zone',
  'challengeZone',
  'workflowZone',
  'contentZone',
  'defaultSchoolZone',
  'timeTableZone',
];
export const defaultNamespace: namespacesType = 'common';
export const languageStorageName = 'preferred_language';
export const languageURL = 'http://knektu-devcms.desap.net/locales/{{lng}}/{{ns}}.json';

export const languages: languageType[] = [
  { code: 'en', title: 'English' },
  { code: 'de', title: 'German' },
  { code: 'ar', title: 'Arabic' },
];

/* initial config for i18n - has used in portals and website */
export const initializeI18n: InitOptions = {
  debug: false,
  lng: getCookie(languageStorageName) || 'en',
  fallbackLng: 'en',
  returnObjects: true,
  ns: namespaces,
  defaultNS: defaultNamespace,
  detection: {
    order: ['cookie'],
    lookupCookie: languageStorageName,
    caches: ['cookie'],
  },
  /* backend: {
    loadPath: languageURL,
  }, */
  resources: {
    en: {
      common: commonEN,
      validation: validationEN,
      exceptions: exceptionsEN,
    },
    de: { common: commonDE },
    ar: { common: commonAR },
  },
};

/* Dynamically load and add a namespace */
export const loadModuleNamespace = async (
  moduleName: moduleNamespacesType,
  jsonFiles: { jsonFile: any; lang: localesType }[],
) => {
  if (jsonFiles?.length) {
    jsonFiles.forEach((jsonFile) => {
      i18n.addResourceBundle(jsonFile.lang, moduleName, jsonFile.jsonFile, true, true);
    });
  }
};
